// Passenger API client (token-based, mounted on /api/passenger)
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PASSENGER_API_BASE = `${BACKEND_URL}/api/passenger`;
const TOKEN_KEY = "majhektcl_token";
const USER_KEY = "majhektcl_user";

export const passengerApi = axios.create({ baseURL: PASSENGER_API_BASE });

passengerApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

passengerApi.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    if (window.location.pathname.startsWith("/majhe") && !window.location.pathname.includes("/login")) {
      window.location.href = "/majhe/login";
    }
  }
  return Promise.reject(err);
});

export function getPassengerUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; }
}
export function setPassengerSession(token, user) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}
export function clearPassengerSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
export function isPassengerAuthed() {
  return !!localStorage.getItem(TOKEN_KEY);
}
